<script>
    import { onMount, onDestroy, tick } from "svelte";
    import { slide } from "svelte/transition";
    import { push } from "svelte-spa-router";
    import Header from "../components/Header.svelte";
    import * as api from "../utiles/api";
    import { currentGoBack, accountInfo, inspectFilter } from "../stores/store";
    import { get } from "svelte/store";

    export let params;

    let bplc_code = params.bplc_code;
    let plan_no = params.plan_no;
    let plan_sn = params.plan_sn;
    let qltinsp_se = params.qltinsp_se;

    let detailList = [];       // 상세 검사항목 데이터 (PDN_PRDCTN_PLAN_QLTINSP)
    let selectedMainItem = null; // 요약 헤더 정보
    let isDetailLoading = false;
    let detailFilterAt = "%";   // 필터 셀렉트 ('%', 'Y', 'N')
    let isSummaryExpanded = false; // 상단 주내역 요약카드 접기/펼치기
    let expandedItemIds = {}; // 각 상세 항목별 펼치기 상태

    function toggleItemExpand(sn) {
        expandedItemIds[sn] = !expandedItemIds[sn];
        expandedItemIds = { ...expandedItemIds };
    }
    let scrollContainer;
    let showScrollTop = false;

    $: filteredDetailList = detailList.filter(item => {
        if (!detailFilterAt || detailFilterAt === '%') return true;
        return item.QLTINSP_AT === detailFilterAt;
    });

    $: filteredConfirmedCount = filteredDetailList.filter(item => item.QLTINSP_AT === 'Y').length;

    // 하단 토스트 알림 상태
    let showToast = false;
    let toastMessage = "";

    function triggerToast(msg = "저장이 완료되었습니다.") {
        toastMessage = msg;
        showToast = true;
        setTimeout(() => {
            showToast = false;
        }, 2000);
    }

    // 요약카드 토글 및 스토어/세션 스토리지 보존
    function toggleSummary() {
        isSummaryExpanded = !isSummaryExpanded;
        inspectFilter.update(f => ({ ...f, isSummaryExpanded }));
    }

    // 확인 (Y/N) 토글 시 실시간 배열 반응성 강제 트리거
    function toggleQltInspAt(item) {
        if (!item) return;
        if (item.MODIFY_AT === 'N') return; // 수정불가 항목
        item.QLTINSP_AT = item.QLTINSP_AT === 'Y' ? 'N' : 'Y';
        detailList = detailList; // 상단 확인 N건 수량 카운트 즉시 갱신
    }

    // MES 사원 검색 모달 관련 상태
    let isEmpModalOpen = false;
    let isModalLoading = false;
    let selectedItemForEmp = null; 
    let selectedEmpRow = null;     
    let lastTapTime = 0;           

    let modalSearchEmpno = "";
    let modalSearchKoreanNm = "";
    let modalSearchDept = "";
    let modalSearchHffc = "H";
    let modalScrollContainer;
    let empList = [];

    // 참조 코드 및 부서 코드 리스트
    let badnOptions = [];   
    let managtOptions = []; 
    let ofcpsOptions = [];
    let deptOptions = [];

    function getHffcNm(hffc) {
        if (!hffc) return '-';
        if (hffc === 'H' || hffc === '1') return '재직';
        if (hffc === 'R' || hffc === '2') return '퇴직';
        if (hffc === 'L' || hffc === '3') return '휴직';
        return hffc;
    }

    onMount(async () => {
        currentGoBack.set(goBack);

        // 스토어/세션 스토리지에서 접힘/펼침 상태 및 선택된 주내역 헤더 정보 복원
        const savedFilter = get(inspectFilter);
        if (savedFilter) {
            if (typeof savedFilter.isSummaryExpanded === "boolean") {
                isSummaryExpanded = savedFilter.isSummaryExpanded;
            }
            if (savedFilter.selectedMainItem) {
                selectedMainItem = savedFilter.selectedMainItem;
            }
        }

        await loadReferenceCodes();
        await getDetailData();
    });

    onDestroy(() => {
        currentGoBack.set(null);
    });

    function goBack() {
        inspectFilter.update(f => ({ ...f, isFromDetail: true }));
        push("/InspectList");
    }

    // 참조 코드 목록 호출 (QCM_BADN_TY, QCM_MANAGT_TY)
    async function loadReferenceCodes() {
        try {
            const acc = get(accountInfo);
            const userBplc = acc ? (acc.BPLC_CODE || acc.bplc_code || acc.as_bplccode || acc.gs_bplccode) : null;
            const targetBplc = (bplc_code && bplc_code !== "%") ? bplc_code : (userBplc || "01");

            // [디버그 로그] 로직과 무관, 조회 파라미터 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
            console.log("[InspectDtl FRONT] 참조코드 조회 targetBplc:", targetBplc);
            const bplcParam = `&gs_bplccode=${targetBplc}&as_bplccode=${targetBplc}&bplc_code=${targetBplc}`;

            const badnRes = await api.get(`/inspect/refrn?cl_code=QCM_BADN_TY${bplcParam}`);
            // [디버그 로그] 로직과 무관, API 응답 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
            console.log("[InspectDtl FRONT] 불량내역 응답:", badnRes);
            const rawBadn = badnRes && badnRes.data ? (Array.isArray(badnRes.data) ? badnRes.data : (badnRes.data.data ? badnRes.data.data : [])) : (Array.isArray(badnRes) ? badnRes : []);
            badnOptions = rawBadn.map(rawItem => {
                const itemObj = {};
                if (rawItem && typeof rawItem === 'object') {
                    for (const k of Object.keys(rawItem)) {
                        itemObj[k] = rawItem[k];
                        itemObj[k.toUpperCase()] = rawItem[k];
                        itemObj[k.toLowerCase()] = rawItem[k];
                    }
                }
                itemObj.CODE = itemObj.REFRN_CODE || itemObj.refrn_code || itemObj.refrn_CODE || "";
                itemObj.NAME = itemObj.REFRN_NM || itemObj.refrn_nm || itemObj.refrn_NM || "";
                return itemObj;
            });

            const managtRes = await api.get(`/inspect/refrn?cl_code=QCM_MANAGT_TY${bplcParam}`);
            // [디버그 로그] 로직과 무관, API 응답 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
            console.log("[InspectDtl FRONT] 조치사항 응답:", managtRes);
            const rawManagt = managtRes && managtRes.data ? (Array.isArray(managtRes.data) ? managtRes.data : (managtRes.data.data ? managtRes.data.data : [])) : (Array.isArray(managtRes) ? managtRes : []);
            managtOptions = rawManagt.map(rawItem => {
                const itemObj = {};
                if (rawItem && typeof rawItem === 'object') {
                    for (const k of Object.keys(rawItem)) {
                        itemObj[k] = rawItem[k];
                        itemObj[k.toUpperCase()] = rawItem[k];
                        itemObj[k.toLowerCase()] = rawItem[k];
                    }
                }
                itemObj.CODE = itemObj.REFRN_CODE || itemObj.refrn_code || itemObj.refrn_CODE || "";
                itemObj.NAME = itemObj.REFRN_NM || itemObj.refrn_nm || itemObj.refrn_NM || "";
                return itemObj;
            });

            // 1. 직위 코드 (PNM_EMP_OFCPS)
            const ofcpsRes = await api.get(`/inspect/refrn?cl_code=PNM_EMP_OFCPS${bplcParam}`);
            const rawOfcps = ofcpsRes && ofcpsRes.data ? (Array.isArray(ofcpsRes.data) ? ofcpsRes.data : (ofcpsRes.data.data ? ofcpsRes.data.data : [])) : (Array.isArray(ofcpsRes) ? ofcpsRes : []);
            ofcpsOptions = rawOfcps.map(rawItem => {
                const itemObj = {};
                if (rawItem && typeof rawItem === 'object') {
                    for (const k of Object.keys(rawItem)) {
                        itemObj[k] = rawItem[k];
                        itemObj[k.toUpperCase()] = rawItem[k];
                        itemObj[k.toLowerCase()] = rawItem[k];
                    }
                }
                itemObj.CODE = itemObj.REFRN_CODE || itemObj.refrn_code || "";
                itemObj.NAME = itemObj.REFRN_NM || itemObj.refrn_nm || "";
                return itemObj;
            });

            // 2. 부서 코드 (PNM_DEPT)
            const deptRes = await api.get(`/inspect/dept?as_bplc_code=${targetBplc}`);
            const rawDept = deptRes && deptRes.data ? (Array.isArray(deptRes.data) ? deptRes.data : (deptRes.data.data ? deptRes.data.data : [])) : (Array.isArray(deptRes) ? deptRes : []);
            deptOptions = rawDept.map(rawItem => {
                const itemObj = {};
                if (rawItem && typeof rawItem === 'object') {
                    for (const k of Object.keys(rawItem)) {
                        itemObj[k] = rawItem[k];
                        itemObj[k.toUpperCase()] = rawItem[k];
                        itemObj[k.toLowerCase()] = rawItem[k];
                    }
                }
                itemObj.CODE = itemObj.DEPT_CODE || itemObj.dept_code || "";
                itemObj.NAME = itemObj.DEPT_NM || itemObj.dept_nm || "";
                return itemObj;
            });
        } catch (err) {
            // [디버그 로그] 로직과 무관, 에러 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
            console.error("참조 코드 조회 실패:", err);
        }
    }

    // 상세내역 API 호출
    async function getDetailData() {
        isDetailLoading = true;
        detailList = [];

        try {
            const queryParams = new URLSearchParams();
            if (bplc_code && bplc_code !== "%") queryParams.append("as_bplccode", bplc_code);
            if (plan_no && plan_no !== "%") queryParams.append("as_plan_no", plan_no);
            if (plan_sn !== undefined && plan_sn !== null) queryParams.append("as_plan_sn", plan_sn);
            if (qltinsp_se && qltinsp_se !== "%") queryParams.append("as_qltinsp_se", qltinsp_se);

            // [디버그 로그] 로직과 무관, 요청/응답 확인용 콘솔 출력 - 필요시 이 블록만 찾아 수정/제거
            console.log("[InspectDtl FRONT] ===== 상세내역 API 요청 =====");
            console.log("[InspectDtl FRONT] 요청 URL:", `/inspect/dtl?${queryParams.toString()}`);

            const response = await api.get(`/inspect/dtl?${queryParams.toString()}`);
            console.log("[InspectDtl FRONT] 상세내역 수신 응답:", response);

            const listData = response && response.data && response.data.data ? response.data.data : (response && response.data ? response.data : null);
            if (listData && Array.isArray(listData)) {
                detailList = listData.map(rawItem => {
                    const itemObj = {};
                    if (rawItem && typeof rawItem === 'object') {
                        for (const k of Object.keys(rawItem)) {
                            itemObj[k] = rawItem[k];
                            itemObj[k.toUpperCase()] = rawItem[k];
                            itemObj[k.toLowerCase()] = rawItem[k];
                        }
                    }
                    itemObj.BADN_TY = (itemObj.BADN_TY || itemObj.badn_ty || "").trim();
                    itemObj.MANAGT_TY = (itemObj.MANAGT_TY || itemObj.managt_ty || "").trim();
                    itemObj.QLTINSP_AT = (itemObj.QLTINSP_AT || itemObj.qltinsp_at || "N").trim();
                    return itemObj;
                });

                if (detailList.length > 0) {
                    selectedMainItem = { ...(selectedMainItem || {}), ...detailList[0] };
                }
            } else {
                detailList = [];
            }
        } catch (err) {
            // [디버그 로그] 로직과 무관, 에러 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
            console.error("상세내역 조회 오류:", err);
            detailList = [];
        } finally {
            isDetailLoading = false;
        }
    }

    function handleScroll() {
        if (!scrollContainer) return;
        showScrollTop = scrollContainer.scrollTop > 150;
    }

    function scrollToTop() {
        if (scrollContainer) {
            scrollContainer.scrollTop = 0;
        }
    }

    function getCodeName(options, code) {
        if (!code) return "-";
        const found = options.find(opt => (opt.CODE || opt.REFRN_CODE) === code);
        return found ? (found.NAME || found.REFRN_NM) : code;
    }

    // (L1) ~ (L5) 명칭 포맷
    function formatLevels(item) {
        if (!item) return "";
        const parts = [];
        if (item.LVL1_NM) parts.push(`(L1) ${item.LVL1_NM}`);
        if (item.LVL2_NM) parts.push(`(L2) ${item.LVL2_NM}`);
        if (item.LVL3_NM) parts.push(`(L3) ${item.LVL3_NM}`);
        if (item.LVL4_NM) parts.push(`(L4) ${item.LVL4_NM}`);
        if (item.LVL5_NM) parts.push(`(L5) ${item.LVL5_NM}`);
        return parts.length > 0 ? parts.join(" > ") : "-";
    }

    // 전체 확인 (모든 편집가능 항목 QLTINSP_AT = 'Y')
    function checkAll() {
        if (!detailList || detailList.length === 0) return;
        detailList = detailList.map(item => {
            if (item.MODIFY_AT !== 'N') {
                return { ...item, QLTINSP_AT: 'Y' };
            }
            return item;
        });
    }

    // 전체 미확인 (모든 편집가능 항목 QLTINSP_AT = 'N')
    function uncheckAll() {
        if (!detailList || detailList.length === 0) return;
        detailList = detailList.map(item => {
            if (item.MODIFY_AT !== 'N') {
                return { ...item, QLTINSP_AT: 'N' };
            }
            return item;
        });
    }

    let isSaving = false;

    async function saveData() {
        if (isSaving) return;

        const targetList = detailList.filter(item => item.MODIFY_AT !== 'N');
        if (targetList.length === 0) {
            alert("저장할 수 있는 항목이 없습니다.");
            return;
        }

        isSaving = true;
        try {
            const payload = targetList.map(item => ({
                BPLC_CODE: item.BPLC_CODE || item.bplc_code || bplc_code || "01",
                PLAN_NO: item.PLAN_NO || plan_no,
                PLAN_SN: item.PLAN_SN ?? plan_sn,
                ITEM_CODE: item.ITEM_CODE,
                QLTINSP_SE: item.QLTINSP_SE || qltinsp_se,
                QLTINSP_SN: item.QLTINSP_SN,
                QLTINSP_AT: item.QLTINSP_AT || "N",
                BADN_TY: item.BADN_TY || "",
                OPERTOR_EMPNO: item.OPERTOR_EMPNO || "",
                MANAGT_TY: item.MANAGT_TY || "",
                MODIFY_AT: item.MODIFY_AT || "Y",
            }));

            // [디버그 로그] 로직과 무관, 요청 페이로드 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
            console.log("[InspectDtl FRONT] 저장 요청 payload:", payload);
            const res = await api.postJson("/inspect/save", payload);
            console.log("[InspectDtl FRONT] 저장 응답 res:", res);

            if (res && res.code === 200) {
                alert(res.msg || "저장이 완료되었습니다.");
                triggerToast(res.msg || "저장이 완료되었습니다.");
                await getDetailData();
            } else if (res && res.msg) {
                alert(res.msg);
            } else {
                alert("저장 응답을 받지 못했습니다. 콘솔/네트워크 상태를 확인해주세요.");
            }
        } catch (err) {
            // [디버그 로그] 로직과 무관, 에러 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
            console.error("상세내역 저장 오류:", err);
            alert("저장 중 오류가 발생했습니다.");
        } finally {
            isSaving = false;
        }
    }

    // --- MES 사원 조회 모달 제어 ---
    function openEmpModal(item) {
        if (item && item.MODIFY_AT === 'N') return; // 수정불가 항목
        selectedItemForEmp = item;
        modalSearchEmpno = "";
        modalSearchKoreanNm = "";
        modalSearchDept = "";
        modalSearchHffc = "H";
        
        if (item && item.OPERTOR_EMPNO) {
            selectedEmpRow = { EMPNO: item.OPERTOR_EMPNO, KOREAN_NM: item.OPERTOR_EMPNO_NM || "" };
        } else {
            selectedEmpRow = null;
        }
        
        isEmpModalOpen = true;
        searchEmp();
    }

    function closeEmpModal() {
        isEmpModalOpen = false;
        selectedItemForEmp = null;
        selectedEmpRow = null;
    }

    async function searchEmp() {
        isModalLoading = true;
        try {
            const queryParams = new URLSearchParams();
            const acc = get(accountInfo);
            const userBplc = acc ? (acc.BPLC_CODE || acc.bplc_code || acc.as_bplccode || acc.gs_bplccode) : null;
            const targetBplc = (bplc_code && bplc_code !== "%") ? bplc_code : (userBplc || "01");
            if (targetBplc) queryParams.append("as_bplc_code", targetBplc);

            if (modalSearchEmpno) queryParams.append("as_empno", modalSearchEmpno);
            if (modalSearchKoreanNm) queryParams.append("as_korean_nm", modalSearchKoreanNm);
            if (modalSearchDept) queryParams.append("as_dept_nm", modalSearchDept);
            if (modalSearchHffc) queryParams.append("as_hffc", modalSearchHffc);
            
            // [디버그 로그] 로직과 무관, 요청 URL 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
            console.log("[InspectDtl FRONT] 사원 조회 요청 URL:", `/inspect/emp?${queryParams.toString()}`);
            const response = await api.get(`/inspect/emp?${queryParams.toString()}`);
            let data = response && response.data && response.data.data ? response.data.data : (response && response.data ? response.data : []);
            
            if (Array.isArray(data)) {
                empList = data.map(rawItem => {
                    const itemObj = {};
                    if (rawItem && typeof rawItem === 'object') {
                        for (const k of Object.keys(rawItem)) {
                            itemObj[k] = rawItem[k];
                            itemObj[k.toUpperCase()] = rawItem[k];
                            itemObj[k.toLowerCase()] = rawItem[k];
                        }
                    }
                    return itemObj;
                });
            } else {
                empList = [];
            }
        } catch (err) {
            // [디버그 로그] 로직과 무관, 에러 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
            console.error("사원 조회 실패:", err);
            empList = [];
        } finally {
            isModalLoading = false;
        }
    }

    function selectEmpRow(emp) {
        if (selectedEmpRow && selectedEmpRow.EMPNO === emp.EMPNO) {
            selectedEmpRow = null;
        } else {
            selectedEmpRow = emp;
        }
    }

    function handleCardTouchOrClick(emp) {
        const currentTime = new Date().getTime();
        const tapLength = currentTime - lastTapTime;

        selectEmpRow(emp);

        if (tapLength < 300 && tapLength > 0) {
            applySelectedEmp();
        }
        lastTapTime = currentTime;
    }

    function applySelectedEmp() {
        if (!selectedEmpRow) {
            alert("선택된 사원이 없습니다.");
            return;
        }
        if (selectedItemForEmp) {
            selectedItemForEmp.OPERTOR_EMPNO = selectedEmpRow.EMPNO;
            selectedItemForEmp.OPERTOR_EMPNO_NM = selectedEmpRow.KOREAN_NM;
            detailList = [...detailList]; // Svelte 반응성 갱신
        }
        closeEmpModal();
    }

    async function clearSelectedEmp() {
        // 모달은 닫지 않고 선택 상태 + 조회조건만 초기화 후 목록을 다시 조회하여 맨 위로 스크롤
        selectedEmpRow = null;
        modalSearchEmpno = "";
        modalSearchKoreanNm = "";
        modalSearchDept = "";
        modalSearchHffc = "H";

        await searchEmp();
        await tick();

        if (modalScrollContainer) {
            modalScrollContainer.scrollTop = 0;
        }
    }

    function clearOpertor(item) {
        if (item && item.MODIFY_AT === 'N') return; // 수정불가 항목
        item.OPERTOR_EMPNO = null;
        item.OPERTOR_EMPNO_NM = null;
        detailList = [...detailList]; // Svelte 반응성 갱신
    }
</script>

<Header {goBack} />

<!-- MES 사원 조회 모달 -->
{#if isEmpModalOpen}
    <div class="mes-modal-overlay">
        <div class="mes-modal-container">
            <div class="mes-modal-header">
                <h3>MES 사원 조회</h3>
                <button class="modal-close-icon" on:click={closeEmpModal}>✕</button>
            </div>

            <div class="mes-modal-search-card">
                <div class="modal-search-grid-4">
                    <div class="modal-filter-group">
                        <label for="m_empno">사원번호</label>
                        <input id="m_empno" type="text" bind:value={modalSearchEmpno} placeholder="사번 입력" class="modal-input" />
                    </div>
                    <div class="modal-filter-group">
                        <label for="m_koreannm">성명</label>
                        <input id="m_koreannm" type="text" bind:value={modalSearchKoreanNm} placeholder="이름 입력" class="modal-input" />
                    </div>
                    <div class="modal-filter-group">
                        <label for="m_dept">부서명</label>
                        {#if deptOptions && deptOptions.length > 0}
                            <select id="m_dept" bind:value={modalSearchDept} class="modal-select">
                                <option value="">전체</option>
                                {#each deptOptions as dept}
                                    <option value={dept.NAME}>{dept.NAME}</option>
                                {/each}
                            </select>
                        {:else}
                            <input id="m_dept" type="text" bind:value={modalSearchDept} placeholder="부서 입력" class="modal-input" />
                        {/if}
                    </div>
                    <div class="modal-filter-group">
                        <label for="m_hffc">재직구분</label>
                        <select id="m_hffc" bind:value={modalSearchHffc} class="modal-select">
                            <option value="">전체</option>
                            <option value="H">재직</option>
                            <option value="R">퇴직</option>
                            <option value="L">휴직</option>
                        </select>
                    </div>
                </div>

                <div class="modal-search-btn-row">
                    <button class="action-btn search-btn modal-search-btn" on:click={searchEmp}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                        조회
                    </button>
                </div>
            </div>

            <div class="mes-modal-body scroll-custom" bind:this={modalScrollContainer}>
                {#if isModalLoading}
                    <div class="empty-state">사원 정보를 불러오는 중입니다...</div>
                {:else if empList.length === 0}
                    <div class="empty-state">조회된 사원 정보가 없습니다.</div>
                {:else}
                    {#each empList as emp (emp.EMPNO)}
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <div 
                            class="emp-card-item" 
                            class:selected={selectedEmpRow && selectedEmpRow.EMPNO === emp.EMPNO}
                            on:click={() => handleCardTouchOrClick(emp)}
                        >
                            <div class="emp-card-header">
                                <span class="emp-no">{emp.EMPNO}</span>
                                <span class="emp-name">{emp.KOREAN_NM}</span>
                                {#if selectedEmpRow && selectedEmpRow.EMPNO === emp.EMPNO}
                                    <span class="selected-badge">선택됨</span>
                                {/if}
                            </div>
                            <div class="emp-card-grid-4" style="margin-top: 8px;">
                                <div class="info-cell">
                                    <span class="cell-label">사업장</span>
                                    <span class="cell-val">{emp.BPLC_NM || emp.BPLC_CODE || '-'}</span>
                                </div>
                                <div class="info-cell">
                                    <span class="cell-label">재직구분</span>
                                    <span class="cell-val">{getHffcNm(emp.HFFC || emp.HFFC_SE_NM)}</span>
                                </div>
                                <div class="info-cell">
                                    <span class="cell-label">부서명</span>
                                    <span class="cell-val">{emp.DEPT_NM || '-'}</span>
                                </div>
                                <div class="info-cell">
                                    <span class="cell-label">직위명</span>
                                    <span class="cell-val">{emp.OFCPS_NM || emp.OFCPS_CODE || '-'}</span>
                                </div>
                            </div>
                        </div>
                    {/each}
                {/if}
            </div>

            <div class="mes-statusbar" style="display: flex; justify-content: space-between; align-items: center; padding: 10px 14px;">
                <span>총 {empList.length}건</span>
                <div style="display: flex; gap: 8px;">
                    <button class="action-btn search-btn" style="height: 34px; padding: 0 16px; font-size: 13px;" on:click={applySelectedEmp}>
                        선택 적용
                    </button>
                    <button class="action-btn cancel-btn" style="height: 34px; padding: 0 16px; font-size: 13px;" on:click={clearSelectedEmp}>
                        선택 취소
                    </button>
                </div>
            </div>
        </div>
    </div>
{/if}

<!-- svelte-ignore a11y-click-events-have-key-events -->
<section
    bind:this={scrollContainer}
    class="main inner main-pad-36 main-gray scroll-custom"
    style="width: 100%; position: relative; height: calc(100vh - 60px); overflow-y: auto;"
    on:scroll={handleScroll}
>
    <div class="mobile">
        <!-- 검사항목 상세내역 UI (상단 데이터 고정 떠있음) -->
        <div style="position: sticky; top: 0; z-index: 100; background: #FFF; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.08); padding: 12px 14px;">
            <div class="cmn-title-left" style="display: flex; justify-content: space-between; align-items: center;">
                <p style="font-size: 20px; font-weight: 700; color: #2D3C48;">검사항목 상세내역</p>
                <span class="total-count-tag">총 {filteredDetailList.length}건 / 확인 {filteredConfirmedCount}건</span>
            </div>

            {#if selectedMainItem}
                <!-- 단일 고정 요약 카드 (CSS 3D 하모닉 아코디언 애니메이션) -->
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <div 
                    class="summary-card-toggle"
                    on:click={toggleSummary}
                >
                    <!-- 항상 상단 고정 헤더 라인 -->
                    <div class="summary-toggle-header">
                        <div class="header-left-info">
                            <span class="info-title">주 내역 정보</span>
                            <span class="info-sep">|</span>
                            <span class="info-item-nm">{selectedMainItem.ITEM_NM || '-'}</span>
                        </div>
                        <span class="toggle-btn-text">
                            {#if isSummaryExpanded}
                                정보 접기 ▲
                            {:else}
                                정보 펼치기 ▼
                            {/if}
                        </span>
                    </div>

                    <!-- 슬라이드로 부드럽게 펼쳐지고 접히는 상세 3줄 박스 -->
                    <div class="summary-expandable-body" class:expanded={isSummaryExpanded}>
                        <div class="expandable-inner-content">
                            <!-- 줄 1: 생산계획번호 | 생산계획순번 | 작업장 -->
                            <div class="card-multi-row col-3" style="gap: 6px;">
                                <div class="info-cell">
                                    <span class="cell-label" style="font-size: 13px; font-weight: 700; color: #64748B;">생산계획번호</span>
                                    <span class="cell-val bold" style="font-size: 15px; color: #0F172A; font-weight: 700;">{selectedMainItem.PLAN_NO || '-'}</span>
                                </div>
                                <div class="info-cell">
                                    <span class="cell-label" style="font-size: 13px; font-weight: 700; color: #64748B;">생산계획순번</span>
                                    <span class="cell-val" style="font-size: 15px; color: #0F172A; font-weight: 700;">{selectedMainItem.PLAN_SN ?? '-'}</span>
                                </div>
                                <div class="info-cell">
                                    <span class="cell-label" style="font-size: 13px; font-weight: 700; color: #64748B;">작업장</span>
                                    <span class="cell-val bold" style="font-size: 15px; color: #0F172A; font-weight: 700;">{selectedMainItem.WRKSHP_NM || '-'}</span>
                                </div>
                            </div>

                            <!-- 줄 2: 품목코드 | 품목명 -->
                            <div class="card-multi-row col-2" style="gap: 6px; margin-top: 6px;">
                                <div class="info-cell">
                                    <span class="cell-label" style="font-size: 13px; font-weight: 700; color: #64748B;">품목코드</span>
                                    <span class="cell-val bold" style="font-size: 15px; color: #0F172A; font-weight: 700;">{selectedMainItem.ITEM_CODE || '-'}</span>
                                </div>
                                <div class="info-cell flex-2">
                                    <span class="cell-label" style="font-size: 13px; font-weight: 700; color: #64748B;">품목명</span>
                                    <span class="cell-val bold" style="font-size: 15px; color: #0F172A; font-weight: 700;">{selectedMainItem.ITEM_NM || '-'}</span>
                                </div>
                            </div>

                            <!-- 줄 3: 등분 | 방향 | 가스 | 전기 -->
                            <div class="card-multi-row col-4" style="gap: 6px; margin-top: 6px;">
                                <div class="info-cell">
                                    <span class="cell-label" style="font-size: 13px; font-weight: 700; color: #64748B;">등분</span>
                                    <span class="cell-val" style="font-size: 15px; color: #0F172A; font-weight: 700;">{selectedMainItem.DEUNGBUN || '-'}</span>
                                </div>
                                <div class="info-cell">
                                    <span class="cell-label" style="font-size: 13px; font-weight: 700; color: #64748B;">방향</span>
                                    <span class="cell-val" style="font-size: 15px; color: #0F172A; font-weight: 700;">{selectedMainItem.DRC || '-'}</span>
                                </div>
                                <div class="info-cell">
                                    <span class="cell-label" style="font-size: 13px; font-weight: 700; color: #64748B;">가스</span>
                                    <span class="cell-val" style="font-size: 15px; color: #0F172A; font-weight: 700;">{selectedMainItem.GAS || '-'}</span>
                                </div>
                                <div class="info-cell">
                                    <span class="cell-label" style="font-size: 13px; font-weight: 700; color: #64748B;">전기</span>
                                    <span class="cell-val" style="font-size: 15px; color: #0F172A; font-weight: 700;">{selectedMainItem.ELCTY || '-'}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            {/if}

            <!-- 1행: 조회조건 셀렉트 & 전체 확인 & 전체 미확인 (한 줄 3등분) -->
            <div class="action-btn-group" style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 6px; margin-top: 8px;">
                <select id="detail_at_select" bind:value={detailFilterAt} class="search-select" style="width: 100%; height: 40px; font-weight: 700; font-size: 11.5px; text-align: center; text-align-last: center; padding: 0 2px;">
                    <option value="%">전체조회(확인/미확인)</option>
                    <option value="Y">확인</option>
                    <option value="N">미확인</option>
                </select>
                <button 
                    type="button"
                    class="dtl-btn btn-check-all" 
                    on:click={checkAll}
                >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    전체 확인
                </button>
                <button 
                    type="button"
                    class="dtl-btn btn-uncheck-all" 
                    on:click={uncheckAll}
                >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                    전체 미확인
                </button>
            </div>

            <!-- 2행: 저장 버튼 (단독 한 줄 100% 폭) -->
            <div style="margin-top: 6px;">
                <button 
                    type="button"
                    class="dtl-btn btn-save" 
                    on:click={saveData} 
                    disabled={isSaving}
                    style="width: 100%; height: 42px; font-size: 15px; font-weight: 700;"
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
                    {isSaving ? "저장 중..." : "저장"}
                </button>
            </div>
        </div>

        <!-- 상세 검사항목 리스트 -->
        <div class="inspect-card-list" style="margin-top: 16px; padding-bottom: 80px;">
            {#if isDetailLoading}
                <div style="background: #FFF; border-radius: 12px; padding: 40px 20px; text-align: center; color: #1E293B; font-size: 14px; font-weight: 700; box-shadow: 0 2px 8px rgba(0,0,0,0.04);">
                    상세 검사항목 데이터를 불러오는 중입니다...
                </div>
            {:else if filteredDetailList.length === 0}
                <div style="background: #FFF; border-radius: 12px; padding: 40px 20px; text-align: center; color: #94A3B8; font-size: 14px; box-shadow: 0 2px 8px rgba(0,0,0,0.04);">
                    조회된 상세 검사항목 데이터가 없습니다.
                </div>
            {:else}
                {#each filteredDetailList as dtlItem, idx (dtlItem.QLTINSP_SN + '_' + idx)}
                    <div 
                        class="inspect-card" 
                        class:is-confirmed={dtlItem.QLTINSP_AT === 'Y'}
                        style="padding: 14px; border-radius: 12px; margin-bottom: 12px; transition: all 0.2s ease;
                            {dtlItem.QLTINSP_AT === 'Y' 
                                ? 'background: #F0FDF4; border: 2px solid #059669; box-shadow: 0 4px 12px rgba(5,150,105,0.12);' 
                                : 'background: #FFFFFF; border: 1px solid #CBD5E1; box-shadow: 0 2px 8px rgba(0,0,0,0.06);'}"
                    >
                        <!-- 카드 헤더: 좌측 [No.순번], 우측 [확인 활성화/비활성화] 토글 버튼 -->
                        <div class="inspect-card-header" style="display: flex; justify-content: space-between; align-items: center; padding-bottom: 10px; border-bottom: {dtlItem.QLTINSP_AT === 'Y' ? '1px solid #DCFCE7' : '1px solid #F1F5F9'};">
                            <div class="inspect-header-left" style="display: flex; align-items: center; gap: 6px;">
                                <span 
                                    class="sn-badge" 
                                    style="font-weight: 800; font-size: 13px; padding: 4px 12px; border-radius: 6px; transition: all 0.2s ease;
                                        {dtlItem.QLTINSP_AT === 'Y' 
                                            ? 'color: #FFFFFF; background: #059669; box-shadow: 0 2px 6px rgba(5, 150, 105, 0.3);' 
                                            : 'color: #1E293B; background: #E2E8F0;'}"
                                >
                                    {dtlItem.QLTINSP_AT === 'Y' ? '✓ ' : ''}No.{dtlItem.QLTINSP_SN || (idx + 1)}
                                </span>
                            </div>

                            <!-- 확인 활성화 / 비활성화 토글 버튼 (우측 상단 강조) -->
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <button
                                type="button"
                                class="qlt-check-btn"
                                class:active={dtlItem.QLTINSP_AT === 'Y'}
                                on:click={() => toggleQltInspAt(dtlItem)}
                                disabled={dtlItem.MODIFY_AT === 'N'}
                                style="border: none; cursor: pointer; padding: 6px 12px; border-radius: 20px; font-size: 12px; font-weight: 700; transition: all 0.2s ease; display: flex; align-items: center; gap: 4px;"
                            >
                                <span style="background: {dtlItem.QLTINSP_AT === 'Y' ? '#059669' : '#94A3B8'}; color: #FFF; border-radius: 50%; width: 14px; height: 14px; display: inline-flex; align-items: center; justify-content: center; font-size: 10px;">✓</span>
                                <span style="color: {dtlItem.QLTINSP_AT === 'Y' ? '#059669' : '#64748B'};">확인</span>
                            </button>
                        </div>

                        <div class="inspect-card-body" style="display: flex; flex-direction: column; gap: 6px; margin-top: 10px;">
                            <!-- 클릭 가능 기본 정보 영역 (구분, 검사항목, 판정기준 1줄 3등분) -->
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <div 
                                class="dtl-basic-info-area"
                                style="cursor: pointer; display: flex; flex-direction: column; gap: 6px;"
                                on:click={() => toggleItemExpand(dtlItem.QLTINSP_SN || idx)}
                            >
                                <div class="card-multi-row col-3" style="gap: 8px;">
                                    <div class="info-cell">
                                        <span class="cell-label" style="font-size: 13px; color: #64748B; font-weight: 700;">구분</span>
                                        <span class="cell-val bold" style="font-size: 14px; color: #0F172A; font-weight: 700;">{dtlItem.LVL1_NM || '-'}</span>
                                    </div>
                                    <div class="info-cell">
                                        <span class="cell-label" style="font-size: 13px; color: #64748B; font-weight: 700;">검사항목</span>
                                        <span class="cell-val bold" style="font-size: 14px; color: #0F172A; font-weight: 700;">{dtlItem.LVL2_NM || '-'}</span>
                                    </div>
                                    <div class="info-cell">
                                        <span class="cell-label" style="font-size: 13px; color: #64748B; font-weight: 700;">판정기준</span>
                                        <span class="cell-val bold" style="font-size: 14px; color: #0F172A; font-weight: 700;">{dtlItem.LVL3_NM || '-'}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- 정보 펼치기 / 정보 접기 토글 바 (주내역 요약카드 스타일과 통일) -->
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <div 
                                class="dtl-item-toggle-bar"
                                on:click={() => toggleItemExpand(dtlItem.QLTINSP_SN || idx)}
                            >
                                <span class="toggle-btn-text">
                                    {#if expandedItemIds[dtlItem.QLTINSP_SN || idx]}
                                        정보 접기 ▲
                                    {:else}
                                        정보 펼치기 ▼
                                    {/if}
                                </span>
                            </div>

                            <!-- 정보 펼치기 시 추가 표시 3개 항목: 불량내역, 조치사항, 작업자 -->
                            {#if expandedItemIds[dtlItem.QLTINSP_SN || idx]}
                                <div transition:slide={{ duration: 200 }} class="dtl-item-expanded-content" style="margin-top: 4px; padding-top: 8px; border-top: 1px dashed #CBD5E1; display: flex; flex-direction: column; gap: 8px;">
                                    <!-- 불량내역 & 조치사항 -->
                                    <div class="card-multi-row col-2" style="gap: 8px;">
                                        <div class="info-cell">
                                            <span class="cell-label" style="font-size: 13px; color: #64748B; font-weight: 700;">불량내역</span>
                                            {#if dtlItem.MODIFY_AT === 'N'}
                                                <span class="cell-val" style="font-size: 15px; color: #0F172A; font-weight: 700;">{getCodeName(badnOptions, dtlItem.BADN_TY)}</span>
                                            {:else}
                                                <select class="search-select" style="height: 38px; width: 100%; font-size: 14px; font-weight: 700; color: #0F172A;" bind:value={dtlItem.BADN_TY}>
                                                    <option value="">선택 안함</option>
                                                    {#each badnOptions as opt}
                                                        <option value={opt.CODE || opt.REFRN_CODE}>{opt.NAME || opt.REFRN_NM}</option>
                                                    {/each}
                                                </select>
                                            {/if}
                                        </div>
                                        <div class="info-cell">
                                            <span class="cell-label" style="font-size: 13px; color: #64748B; font-weight: 700;">조치사항</span>
                                            {#if dtlItem.MODIFY_AT === 'N'}
                                                <span class="cell-val" style="font-size: 15px; color: #0F172A; font-weight: 700;">{getCodeName(managtOptions, dtlItem.MANAGT_TY)}</span>
                                            {:else}
                                                <select class="search-select" style="height: 38px; width: 100%; font-size: 14px; font-weight: 700; color: #0F172A;" bind:value={dtlItem.MANAGT_TY}>
                                                    <option value="">선택 안함</option>
                                                    {#each managtOptions as opt}
                                                        <option value={opt.CODE || opt.REFRN_CODE}>{opt.NAME || opt.REFRN_NM}</option>
                                                    {/each}
                                                </select>
                                            {/if}
                                        </div>
                                    </div>

                                    <!-- 작업자 -->
                                    <div class="info-cell">
                                        <span class="cell-label" style="font-size: 13px; color: #64748B; font-weight: 700;">작업자</span>
                                        {#if dtlItem.MODIFY_AT === 'N'}
                                            <span class="cell-val" style="font-size: 15px; color: #0F172A; font-weight: 700; margin-top: 2px;">
                                                {dtlItem.OPERTOR_EMPNO ? (dtlItem.OPERTOR_EMPNO_NM ? `${dtlItem.OPERTOR_EMPNO} (${dtlItem.OPERTOR_EMPNO_NM})` : dtlItem.OPERTOR_EMPNO) : '-'}
                                            </span>
                                        {:else}
                                            <div style="display: flex; align-items: center; gap: 6px; margin-top: 2px;">
                                                <div style="position: relative; display: flex; align-items: center; flex: 1;">
                                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                                    <input
                                                        type="text"
                                                        class="search-input-date"
                                                        style="height: 38px; width: 100%; background: #F8FAFC; border: 1px solid #CBD5E1; border-radius: 8px; font-size: 14px; font-weight: 700; color: #0F172A; padding-left: 12px; padding-right: 75px; cursor: pointer;"
                                                        readonly
                                                        value={dtlItem.OPERTOR_EMPNO ? (dtlItem.OPERTOR_EMPNO_NM ? `${dtlItem.OPERTOR_EMPNO} (${dtlItem.OPERTOR_EMPNO_NM})` : dtlItem.OPERTOR_EMPNO) : ''}
                                                        placeholder="작업자 선택"
                                                        on:click={() => openEmpModal(dtlItem)}
                                                    />
                                                    <button
                                                        type="button"
                                                        class="emp-search-btn"
                                                        style="position: absolute; right: 4px; height: 30px; padding: 0 12px; font-size: 13px; font-weight: 700; border-radius: 6px; display: flex; align-items: center; gap: 4px;"
                                                        on:click={() => openEmpModal(dtlItem)}
                                                    >
                                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                                                        조회
                                                    </button>
                                                </div>
                                                <button
                                                    type="button"
                                                    class="emp-clear-btn"
                                                    style="height: 38px; padding: 0 12px; font-size: 13px; font-weight: 700; border-radius: 8px; display: flex; align-items: center; gap: 4px; flex-shrink: 0;"
                                                    on:click={() => clearOpertor(dtlItem)}
                                                >
                                                    초기화
                                                </button>
                                            </div>
                                        {/if}
                                    </div>
                                </div>
                            {/if}
                        </div>
                    </div>
                {/each}
            {/if}
        </div>
    </div>

    <!-- 우측 하단 플로팅 맨위로 버튼 -->
    {#if showScrollTop}
        <button class="scroll-top-btn" on:click={scrollToTop} aria-label="맨위로 이동">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="18 15 12 9 6 15"/>
            </svg>
            <span>TOP</span>
        </button>
    {/if}

    <!-- 하단 토스트 알림 메시지 -->
    {#if showToast}
        <div class="bottom-toast-notification">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            <span>{toastMessage}</span>
        </div>
    {/if}
</section>

<style>
    /* MES 모바일 대칭 정중앙 세로 90% 높이 차지 팝업 모달 */
    .mes-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: rgba(15, 23, 42, 0.65);
        backdrop-filter: blur(4px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100000;
        padding: 16px;
        box-sizing: border-box;
    }

    .mes-modal-container {
        width: 100%;
        max-width: 480px;
        height: 90vh;
        max-height: 900px;
        background: #FFFFFF;
        border-radius: 16px;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .mes-modal-header {
        padding: 14px 18px;
        background: #1E293B;
        color: #FFFFFF;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .mes-modal-header h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
    }

    .modal-close-icon {
        background: transparent;
        border: none;
        color: #94A3B8;
        font-size: 20px;
        cursor: pointer;
        padding: 4px 8px;
    }

    .mes-modal-search-card {
        padding: 12px 14px;
        background: #F8FAFC;
        border-bottom: 1px solid #E2E8F0;
    }

    .modal-search-grid-4 {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
    }

    .modal-filter-group {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .modal-filter-group label {
        font-size: 11px;
        font-weight: 600;
        color: #475569;
    }

    .modal-input, .modal-select {
        width: 100%;
        height: 34px;
        padding: 0 8px;
        border-radius: 6px;
        border: 1px solid #CBD5E1;
        font-size: 13px;
        color: #1E293B;
        background: #FFFFFF;
        box-sizing: border-box;
    }

    .modal-search-btn-row {
        margin-top: 8px;
        display: flex;
        justify-content: flex-end;
    }

    .modal-search-btn {
        height: 34px;
        padding: 0 16px;
        font-size: 13px;
    }

    .mes-modal-body {
        flex: 1;
        overflow-y: auto;
        padding: 12px 14px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        background: #F1F5F9;
    }

    .emp-card-item {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 10px;
        padding: 12px;
        cursor: pointer;
        position: relative;
        transition: all 0.15s ease;
    }

    .emp-card-item.selected {
        border-color: #2563EB;
        background: #EFF6FF;
        box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
    }

    .emp-card-header {
        display: flex;
        align-items: center;
        gap: 8px;
        border-bottom: 1px solid #F1F5F9;
        padding-bottom: 6px;
    }

    .emp-no {
        font-size: 13px;
        font-weight: 700;
        color: #475569;
    }

    .emp-name {
        font-size: 15px;
        font-weight: 700;
        color: #0F172A;
    }

    .selected-badge {
        position: absolute;
        top: 10px;
        right: 12px;
        font-size: 11px;
        font-weight: 700;
        color: #2563EB;
        background: #DBEAFE;
        border: 1px solid #93C5FD;
        padding: 2px 8px;
        border-radius: 10px;
    }

    .emp-card-grid-4 {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px 14px;
    }

    .info-cell {
        display: flex;
        flex-direction: column;
        gap: 3px;
        text-align: left;
    }
    .cell-label {
        font-size: 13px;
        color: #64748B;
        font-weight: 600;
        font-family: Inter, 'Noto Sans CJK KR', sans-serif;
        letter-spacing: -0.1px;
    }
    .cell-val {
        font-size: 15px;
        color: #4A4A4A;
        font-weight: 600;
        font-family: Inter, 'Noto Sans CJK KR', sans-serif;
        letter-spacing: -0.1px;
    }
    .cell-val.bold {
        font-size: 16px;
        font-weight: 700;
        color: #0F172A;
    }

    .empty-state {
        text-align: center;
        padding: 40px 0;
        font-size: 13px;
        color: #94A3B8;
    }

    .mes-statusbar {
        padding: 8px 10px;
        background: #E2E8F0;
        border-top: 1px solid #CBD5E1;
        font-size: 11px;
        color: #475569;
        text-align: center;
        box-sizing: border-box;
    }

    .action-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        height: 42px;
        border-radius: 8px;
        border: none;
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.2s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    }
    .action-btn:active {
        transform: scale(0.97);
    }
    .action-btn.search-btn {
        background: #2563EB;
        color: #FFFFFF;
    }
    .action-btn.search-btn:hover {
        background: #1D4ED8;
    }
    .action-btn.cancel-btn {
        background: #64748B;
        color: #FFFFFF;
    }
    .action-btn.cancel-btn:hover {
        background: #475569;
    }

    .scroll-top-btn {
        position: fixed;
        bottom: 24px;
        right: 20px;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background: #1E293B;
        color: #FFFFFF;
        border: none;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 999;
        transition: transform 0.15s ease, background-color 0.2s ease;
    }
    .scroll-top-btn:active {
        transform: scale(0.92);
        background: #0F172A;
    }
    .scroll-top-btn span {
        font-size: 9px;
        font-weight: 800;
        line-height: 1;
        margin-top: 1px;
        letter-spacing: 0.5px;
    }

    .info-line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 0;
    }
    .info-label {
        font-size: 14px;
        font-weight: 600;
        color: #475569;
        min-width: 90px;
    }
    .info-val {
        flex: 1;
        display: flex;
        justify-content: flex-end;
    }
    .emp-search-group {
        display: flex;
        gap: 6px;
        width: 100%;
    }
    .emp-search-btn {
        padding: 0 14px;
        border-radius: 6px;
        background: #3B82F6;
        color: #FFF;
        font-size: 13px;
        font-weight: 700;
        border: none;
        cursor: pointer;
        white-space: nowrap;
    }
    .emp-search-btn:active {
        background: #2563EB;
    }
    .emp-clear-btn {
        border-radius: 8px;
        background: #F1F5F9;
        color: #475569;
        border: 1px solid #CBD5E1;
        cursor: pointer;
        white-space: nowrap;
    }
    .emp-clear-btn:active {
        background: #E2E8F0;
    }

    .inspect-card-list {
        display: flex;
        flex-direction: column;
        gap: 14px;
        font-family: Inter, 'Noto Sans CJK KR', sans-serif;
        font-feature-settings: 'clig' off, 'liga' off;
        letter-spacing: -0.1px;
    }

    .inspect-card {
        background: #FFFFFF;
        border-radius: 10px;
        border: 1px solid #E2E8F0;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
        padding: 12px 14px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        font-family: Inter, 'Noto Sans CJK KR', sans-serif;
        font-feature-settings: 'clig' off, 'liga' off;
        letter-spacing: -0.1px;
    }

    .inspect-card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 8px;
        border-bottom: 1px solid #F1F5F9;
    }

    .inspect-header-left {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .sn-badge {
        font-size: 13px;
        font-weight: 700;
        color: #1E293B;
        background: #F1F5F9;
        padding: 3px 8px;
        border-radius: 6px;
    }

    .card-multi-row {
        display: flex;
        gap: 12px;
        align-items: center;
    }
    .card-multi-row.col-3 .info-cell {
        flex: 1;
    }
    .card-multi-row.col-2 .info-cell {
        flex: 1;
    }
    .card-multi-row.col-2 .info-cell.flex-2 {
        flex: 2;
    }
    .card-multi-row.col-4 .info-cell {
        flex: 1;
    }
    .search-input-date, .search-select {
        height: 38px;
        padding: 0 8px;
        border-radius: 6px;
        border: 1px solid #CBD5E1;
        font-size: 14px;
        color: #4A4A4A;
        background: #FFFFFF;
        font-family: Inter, 'Noto Sans CJK KR', sans-serif;
        box-sizing: border-box;
    }

    .summary-card-toggle {
        margin-top: 8px;
        background: #F8FAFC;
        border: 1px solid #E2E8F0;
        border-radius: 10px;
        padding: 8px 12px;
        cursor: pointer;
        user-select: none;
        transition: background-color 0.2s ease, border-color 0.2s ease;
    }
    .summary-card-toggle:hover {
        background: #F1F5F9;
        border-color: #CBD5E1;
    }
    .summary-toggle-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .header-left-info {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 13px;
        color: #1E293B;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .info-title {
        font-weight: 700;
        color: #475569;
    }
    .info-sep {
        color: #CBD5E1;
    }
    .info-item-nm {
        color: #0F172A;
        font-weight: 700;
    }
    .toggle-btn-text {
        font-size: 12px;
        font-weight: 700;
        color: #2563EB;
        display: flex;
        align-items: center;
        gap: 4px;
        white-space: nowrap;
    }
    .summary-expandable-body {
        max-height: 0;
        opacity: 0;
        overflow: hidden;
        transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease, margin-top 0.3s ease;
        margin-top: 0;
    }
    .summary-expandable-body.expanded {
        max-height: 250px;
        opacity: 1;
        margin-top: 8px;
    }
    .expandable-inner-content {
        border-top: 1px dashed #CBD5E1;
        padding-top: 8px;
    }

    .qlt-check-btn {
        background: #F1F5F9;
        border: 1px solid #E2E8F0 !important;
    }
    .qlt-check-btn.active {
        background: #ECFDF5;
        border: 1px solid #A7F3D0 !important;
    }
    .qlt-check-btn:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }

    .bottom-toast-notification {
        position: fixed;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        background: #1E293B;
        color: #FFFFFF;
        padding: 10px 22px;
        border-radius: 20px;
        font-size: 14px;
        font-weight: 700;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
        z-index: 10000;
        animation: fadeInUp 0.25s ease;
        display: flex;
        align-items: center;
        gap: 6px;
    }
    @keyframes fadeInUp {
        from { opacity: 0; transform: translate(-50%, 15px); }
        to { opacity: 1; transform: translate(-50%, 0); }
    }

    /* 하단 3등분 버튼 스타일 (전체 확인 / 전체 미확인 / 저장) */
    .dtl-btn {
        height: 40px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 3px;
        border: none;
        cursor: pointer;
        transition: all 0.2s ease;
        padding: 0 2px;
        white-space: nowrap;
        box-sizing: border-box;
    }
    .btn-check-all {
        background: #059669;
        color: #FFFFFF;
        box-shadow: 0 2px 6px rgba(5, 150, 105, 0.25);
    }
    .btn-check-all:hover {
        background: #047857;
    }
    .btn-uncheck-all {
        background: #64748B;
        color: #FFFFFF;
        box-shadow: 0 2px 6px rgba(100, 116, 139, 0.25);
    }
    .btn-uncheck-all:hover {
        background: #475569;
    }
    .btn-save {
        background: #2563EB;
        color: #FFFFFF;
        box-shadow: 0 2px 6px rgba(37, 99, 235, 0.25);
    }
    .btn-save:hover {
        background: #1D4ED8;
    }
    .dtl-btn:active {
        transform: scale(0.97);
    }
    .dtl-btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    /* 상세항목 개별 펼치기 토글 바 스타일 (주내역 요약카드 디자인과 통일) */
    .dtl-item-toggle-bar {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 12px;
        margin-top: 4px;
        background: #F8FAFC;
        border-radius: 6px;
        border: 1px solid #E2E8F0;
        cursor: pointer;
        user-select: none;
        transition: all 0.2s ease;
    }
    .dtl-item-toggle-bar:hover {
        background: #F1F5F9;
        border-color: #CBD5E1;
    }
    .dtl-item-toggle-bar .toggle-btn-text {
        font-size: 12px;
        font-weight: 700;
        color: #475569;
    }
    .dtl-basic-info-area {
        border-radius: 6px;
        padding: 4px;
        transition: background 0.15s ease;
    }
    .dtl-basic-info-area:hover {
        background: rgba(241, 245, 249, 0.6);
    }
</style>
